import Mutations from '../../odata/mutations';

export default { ...new Mutations('crewTopSheetDocument'), ...new Mutations('crewTopSheetDocuments') };
